import { getPublicConfig } from "@/shared/config/config"
import type { HttpClient } from "@/shared/types/HttpClient"
import type { CustomerNeighborsResponse } from "../types/CustomerNeighborsResponse"
import type { RelatedCustomersResponse } from "../types/RelatedCustomersResponse"

const { cmApiBaseUrl } = getPublicConfig()
const customerApiBaseUrl = `${cmApiBaseUrl}/v1/customers`

export const createVisualizationApi = (client: HttpClient) => ({
  getRelatedCustomers: async (customerId: string): Promise<RelatedCustomersResponse> =>
    client.get<RelatedCustomersResponse>(`${customerApiBaseUrl}/${customerId}/related_customers`),

  getCustomerNeighbors: async (ids: string[]): Promise<CustomerNeighborsResponse> =>
    client.get<CustomerNeighborsResponse>(`${customerApiBaseUrl}/neighbors?ids=${ids.join("&ids=")}`)
})
